import api from '@/api/api';
import { createQueryParams } from '@/utils';

const PROFESSIONALS_PUBLIC_PAGE_SIZE = 100;

const getProfessionals = async (
	params: Professionals.ProfessionalParams,
): Promise<Professionals.GetProfessionalsRespose> => {
	const queryParams = createQueryParams({ ...params });
	const { data } = await api.get(`/professional?${queryParams}`);
	return data;
};

/** Busca todas as páginas até trazer a lista completa (agendamento público). */
const getAllProfessionalsPublic = async (
	params: Omit<Professionals.ProfessionalParams, 'page' | 'limit'>,
): Promise<Professionals.GetProfessionalsRespose> => {
	const professionals: Professionals.Professional[] = [];
	let total = 0;
	let page = 1;

	for (;;) {
		const response = await getProfessionals({
			...params,
			page,
			limit: PROFESSIONALS_PUBLIC_PAGE_SIZE,
		});

		const batch = response.professionals ?? response.data ?? [];
		total = response.total ?? batch.length;
		professionals.push(...batch);

		if (batch.length === 0 || professionals.length >= total) {
			break;
		}

		page += 1;
	}

	return { professionals, total };
};

const getProfessionalPublicById = async (
	id: string,
): Promise<Professionals.Professional> => {
	const { data } = await api.get(`/professional/${id}`);
	return data;
};

/** Números públicos do profissional (sessões concluídas, pacientes, desde quando). */
const getProfessionalShowcase = async (
	id: string,
): Promise<Professionals.Showcase> => {
	const { data } = await api.get(`/professional/${id}/showcase`);
	return data;
};

const getServices = async (): Promise<Array<Questions.Question>> => {
	const { data } = await api.get(`/services`);
	return data;
};

const getAvailableDate = async (): Promise<
	Array<AvailableDates.AvailableDate>
> => {
	const { data } = await api.get(`/available-dates`);
	return data;
};

const getAvailableDatePublic = async (
	id: string,
): Promise<AvailableDates.SessionAvailableDatesResponse> => {
	const { data } = await api.get(
		`/public/available-dates/${id}?include_availability=true`,
	);
	return data;
};

const getProfessionalProfession = async (): Promise<
	Services.ServiceProfession[]
> => {
	const { data } = await api.get(`/services?type=PROFESSION`);
	return data;
};

const PublicService = {
	getProfessionals,
	getAllProfessionalsPublic,
	getProfessionalPublicById,
	getProfessionalShowcase,
	getServices,
	getAvailableDate,
	getAvailableDatePublic,
	getProfessionalProfession,
};

export { PublicService };
